//import "./Schemes.css";

export default function Schemes() {
  const schemes = [
    {
      title: "मनरेगा योजना",
      desc: "ग्रामीण भागात रोजगार उपलब्ध करून देण्यासाठी श्रम आधारित प्रकल्प.",
    },
    {
      title: "स्वच्छ भारत मिशन",
      desc: "ग्रामीण भागात स्वच्छता सुधारण्यासाठी शौचालय बांधकाम व जनजागृती.",
    },
    {
      title: "जल जीवन मिशन",
      desc: "प्रत्येक घराला स्वच्छ व सुरक्षित पाणीपुरवठा उपलब्ध करणे.",
    },
    {
      title: "अंगणवाडी सेवा",
      desc: "महिला व बालकांसाठी पोषण, आरोग्य व शिक्षण सुविधा.",
    },
    {
      title: "प्रधानमंत्री आवास योजना",
      desc: "गृहहीन कुटुंबांना घरकुल बांधण्यासाठी आर्थिक मदत.",
    },
    {
      title: "कृषी सहाय्य योजना",
      desc: "शेतकऱ्यांना बियाणे, खत, आधुनिक तंत्रज्ञान प्रशिक्षण.",
    },
  ];

  return (
    <div className="schemes-container">
      <h2>शासकीय योजना</h2>

      <div className="schemes-grid">
        {schemes.map((s, i) => (
          <div className="scheme-card" key={i}>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
